import { useQuery } from '@tanstack/react-query';
import type { RecentSessionsResponse } from '@evi/shared';
import { fetchDashboardRecentSessions } from '@/lib/api';
import { recentSessionsQuery, type SessionsView } from '@/lib/sessionsViews';
import { useDashboardIdentity } from './useDashboardIdentity';

/**
 * Recent sessions widget data, and the dashboard Sessions widget's two
 * views: 'all' (the default here, the latest 10 of every status; the
 * Recent sessions widget's own query and cache) or 'active' (the latest
 * 10 in progress, ?status=active). Keyed by viewer identity like the other
 * dashboard reads, so rows never cross an account or persona change.
 * Live: session events refetch both through LiveUpdatesProvider; no poll.
 * No server-side cache on this endpoint; the query is bounded (top 10
 * sorted) so cost is fixed regardless of fleet size.
 */
export function useDashboardRecentSessions(view: SessionsView = 'all') {
  const identity = useDashboardIdentity();
  const { queryKey, status } = recentSessionsQuery(view, identity);
  return useQuery<RecentSessionsResponse>({
    queryKey,
    queryFn: () => fetchDashboardRecentSessions(status),
    staleTime: 30_000,
  });
}
